export enum AchievementId {
    TotalMoney100 = "total-money-100",
    ExampleAchievement = "example",
}